<template>
  <div class="loading" v-if="loadShow">
    <div class="loading-con">
      <div :class="['boot', 'img_loading']"></div>
      <p>{{ tips }}</p>
    </div>
  </div>
</template>
<script>
import { _getParames } from '@/utils/common';
import * as dingApi from '@/api/dingD';
import * as baseApi from '@/api/base';
export default {
  name: 'home',
  data() {
    return {
      isDD_env: this.$store.state.global.isDD_env,
      isWx_env: this.$store.state.global.isWx_env,
      loadShow: true,
      appCode: '',
      corpId: _getParames('corpId'),
      agentId: _getParames('agentId'),
      userId: this.$store.state.global.userId,
      roleList: JSON.parse(localStorage.getItem('rolesList')), //用户列表
      tips: '',
    };
  },
  created: function () {
    this.$store.dispatch('setCorpId', this.corpId);
    this.$store.dispatch('setAppCode', _getParames('appCode'));
    sessionStorage.setItem('appCode', _getParames('appCode'));
    this.appCode = _getParames('appCode');
    // this.$router.replace({path:'/login'});
    if (this.isDD_env) {
      this.getInit();
    } else if (this.isWx_env) {
      this.getWxInit();
    } else {
      this.tips = '请用钉钉打开...';
    }
  },
  mounted: function () {},
  methods: {
    /****************
     * 内部应用通过临时授权码获取用户信息和用户角色
     * 如果yonghuList>0   钉钉已经绑定了用户无需再次登录
     * *********************/
    getInit() {
      dd.runtime.permission.requestAuthCode({
        corpId: this.corpId,
        onSuccess: async (result) => {
          let data = {
            code: result.code,
            corpId: this.corpId,
          };
          if (this.agentId) {
            data.agentId = this.agentId;
          }
          try {
            const res = await dingApi.getUserListByCode(data);
            console.log(res, '==========res 63========');
            const { resultCode, value } = res;
            console.log(this.userId, this.appCode, '===========65 userId  appCode==========');
            if (resultCode == 1) {
              console.log(resultCode, '==========resultCode 66========');
              let { school = '', yonghuList, dingUserId } = value;
              await this.$store.dispatch('setSchoolCode', school);
              this.$store.dispatch('setDingUserId', dingUserId);
              localStorage.setItem('rolesList', JSON.stringify(yonghuList));
              console.log(yonghuList, '==========yonghuList 71========');
              if (yonghuList.length == 0) {
                console.log(yonghuList, '==========yonghuList 73========');
                this.$router.replace({ path: '/login', query: { school } });
              } else if (yonghuList.length === 1) {
                console.log(yonghuList, '==========yonghuList 76========');
                this.$store.dispatch('setUserInfo', yonghuList[0]);
                if (this.appCode) {
                  this.toOtherPage(yonghuList[0].userId, dingUserId, school);
                } else {
                  this.$router.replace({ path: '/homeIndex' });
                }
              } else {
                console.log(yonghuList, '==========yonghuList 84========');
                let i = yonghuList.findIndex((item) => item.userId === this.userId);
                if (i > -1) {
                  this.$store.dispatch('setUserInfo', yonghuList[0]);
                  if (this.appCode) {
                    this.toOtherPage(yonghuList[0].userId, dingUserId, school);
                  } else {
                    this.$router.replace({ path: '/roles' });
                  }
                } else {
                  this.$router.replace({ path: '/roles' });
                }
              }
            }
          } catch (error) {
            console.warn(error, '========96==========');
          }
        },
        onFail: function (err) {
          console.log(err, '2222');
        },
      });
    },
    // 直接跳转到读书吧或者英语点读
    async toOtherPage(userId, dingUserId, school) {
      let isDD_env = this.$store.state.global.isDD_env;
      let isWx_env = this.$store.state.global.isWx_env;
      let platform = isWx_env ? 6 : isDD_env ? 5 : 0;
      let res = await baseApi.getAppAuthorityList({ school: school, userId: userId, platform: platform });
      if (res && res.resultCode == 1 && res.value && res.value.length > 0) {
        if (res.value.map((item) => item.code).indexOf(this.appCode) > -1) {
          let urls = res.value.filter((item) => item.code == this.appCode)[0].url;
          if (this.appCode == 'kldsb') {
            urls =
              'http://www.91118.com/activity/HappyReadingForDD/#/?duserid=' +
              dingUserId +
              '&FromType=7&corpId=' +
              this.corpId +
              '&userCode=' +
              userId;
            // urls = 'http://localhost:8730/#/?duserid=04251041432353&corpId=ding2f2292681ee1f840&fromType=6&userCode='+ userId
          }
          if (this.appCode == 'yydd') {
            urls =
              'http://www.91118.com/activity/englishreadingForDD/?duserid=' +
              dingUserId +
              '&corpId=' +
              this.corpId +
              '&fromtype=7&userCode=' +
              userId +
              '#/';
            // urls = 'http://localhost:8083/?duserid=04251041432353&corpId=ding2f2292681ee1f840&fromtype=7&userCode='+ userId +'#/'
          }
          window.location.href = urls;
        } else {
          this.$router.replace({ path: '/homeIndex' });
        }
      } else {
        this.$router.replace({ path: '/homeIndex' });
      }
    },
    /**
     * 微信对接
     */
    async getWxInit() {
      let params = {};
      params.xxdm = this.$route.query.xxdm;
      params.usercode = this.$route.query.username;
      params.platform = 6;
      this.$store.dispatch('setSchoolCode', this.$route.query.xxdm);
      let res = await baseApi.getTokenByXxt(params);
      if (res.status == 200) {
        let p = {};
        p.token = res.data;
        let r = await baseApi.getUserBaseInfo(p);
        let userInfo = {};
        userInfo.userFace = r.image;
        userInfo.trueName = r.name;
        userInfo.type = r.type;
        userInfo.schoolName = r.xxmc;
        userInfo.school = r.xxdm;
        userInfo.classCode = '';
        userInfo.className = '';
        userInfo.userId = r.usercode;
        userInfo.xxtyhh = r.xxtyhh;
        this.$store.dispatch('setUserInfo', userInfo);
        this.$router.replace({ path: '/homeIndex' });
      }
    },
  },
};
</script>
